<template>
  <div class="flex flex-col">
    <page-header header="Admin Panel" subheader="Quickly and easily add or modify modules and pages." />

    <div class="flex flex-wrap mb-6 pb-8 -mx-2 border-b">
      <div class="h-32 w-full md:w-1/3 xl:w-1/4 px-2 mb-4">
        <div class="flex flex-col justify-between h-full p-2 pb-4 rounded-lg bg-white">
          <div class="flex items-center p-2">
            <!-- <icon class="icon-xs mr-2" name="Rebranding" /> -->
            <h3 class="text-lg">Create a Page</h3>
          </div>
          <div class="text-center">
            <router-link to="/admin/page"
              class="inline-block no-underline button-text-color px-4 py-2 bg-secondary hover:shadow-inner border border-white rounded text-center uppercase font-medium tracking-wide text-sm leading-tight m-w-1/2">
              Add Page
            </router-link>
          </div>
        </div>
      </div>
      <div class="h-32 w-full md:w-1/3 xl:w-1/4 px-2 mb-4">
        <div class="flex flex-col justify-between h-full p-2 pb-4 rounded-lg bg-white">
          <div class="flex items-center p-2">
            <!-- <icon class="icon-xs mr-2" name="Rebranding" /> -->
            <h3 class="text-lg">Create a Partner Page</h3>
          </div>
          <div class="text-center">
            <router-link to="/admin/partner"
              class="inline-block no-underline button-text-color px-4 py-2 bg-secondary hover:shadow-inner border border-white rounded text-center uppercase font-medium tracking-wide text-sm leading-tight m-w-1/2">
              Add Partner
            </router-link>
          </div>
        </div>
      </div>
      <div class="h-32 w-full md:w-1/3 xl:w-1/4 px-2 mb-4">
        <div class="flex flex-col justify-between h-full p-2 pb-4 rounded-lg bg-white">
          <div class="flex items-center p-2">
            <!-- <icon class="icon-xs mr-2" name="Rebranding" /> -->
            <h3 class="text-lg">Create an Alert</h3>
          </div>
          <div class="text-center">
            <router-link to="/admin/alert"
              class="inline-block no-underline button-text-color px-4 py-2 bg-secondary hover:shadow-inner border border-white rounded text-center uppercase font-medium tracking-wide text-sm leading-tight m-w-1/2">
              Add Alert
            </router-link>
          </div>
        </div>
      </div>
      <div class="h-32 w-full md:w-1/3 xl:w-1/4 px-2 mb-4">
        <div class="flex flex-col justify-between h-full p-2 pb-4 rounded-lg bg-white">
          <div class="flex items-center p-2">
            <!-- <icon class="icon-xs mr-2" name="Rebranding" /> -->
            <h3 class="text-lg">Create a Notification</h3>
          </div>
          <div class="text-center">
            <router-link to="/admin/notify"
              class="inline-block no-underline button-text-color px-4 py-2 bg-secondary hover:shadow-inner border border-white rounded text-center uppercase font-medium tracking-wide text-sm leading-tight m-w-1/2">
              Add Notification
            </router-link>
          </div>
        </div>
      </div>
      <div class="h-32 w-full md:w-1/3 xl:w-1/4 px-2 mb-4">
        <div class="flex flex-col justify-between h-full p-2 pb-4 rounded-lg bg-white">
          <div class="flex items-center p-2">
            <!-- <icon class="icon-xs mr-2" name="Rebranding" /> -->
            <h3 class="text-lg">Create an Event</h3>
          </div>
          <div class="text-center">
            <router-link to="/admin/event"
              class="inline-block no-underline button-text-color px-4 py-2 bg-secondary hover:shadow-inner border border-white rounded text-center uppercase font-medium tracking-wide text-sm leading-tight m-w-1/2">
              Add Event
            </router-link>
          </div>
        </div>
      </div>
      <div class="h-32 w-full md:w-1/3 xl:w-1/4 px-2 mb-4">
        <div class="flex flex-col justify-between h-full p-2 pb-4 rounded-lg bg-white">
          <div class="flex items-center p-2">
            <!-- <icon class="icon-xs mr-2" name="Rebranding" /> -->
            <h3 class="text-lg">Create a News Article</h3>
          </div>
          <div class="text-center">
            <router-link to="/admin/article"
              class="inline-block no-underline button-text-color px-4 py-2 bg-secondary hover:shadow-inner border border-white rounded text-center uppercase font-medium tracking-wide text-sm leading-tight m-w-1/2">
              Add Article
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-6 -mx-2 text-sm">
      <div class="flex flex-wrap justify-between items-baseline">
        <input type="text" name="search" id="search" placeholder="Search for Pages / Alerts" v-model="filters.search"
          class="mb-4 flex-grow input bg-white mx-2 rounded-lg h-16 text-base">
        <pl-select name="filter_menu" id="filter_menu" select-class="bg-white"
          class="mb-4 flex-grow self-center mx-2 w-48" v-model="filters.menu">
          <option :value="null">All Menus</option>
          <option v-for="menu in menus" :key="menu.id" :value="menu.id">{{ menu.name }}</option>
        </pl-select>
        <div class="w-full lg:w-auto mb-4 flex flex-wrap items-center justify-between flex-grow px-4">
          <input id="page_filter" class="mr-1 leading-tight" type="checkbox" v-model="filters.pages">
          <label for="page_filter" class="text-grey-darker font-medium">
            <span class="text-sm uppercase">
              Pages
            </span>
          </label>
          <input id="news_filter" class="mr-1 leading-tight" type="checkbox" v-model="filters.news">
          <label for="news_filter" class="ml-2 text-grey-darker font-medium">
            <span class="text-sm uppercase">
              News
            </span>
          </label>
          <input id="alerts_filters" class="mr-1 leading-tight" type="checkbox" v-model="filters.alerts">
          <label for="alerts_filters" class="ml-2 text-grey-darker font-medium">
            <span class="text-sm uppercase">
              Alerts
            </span>
          </label>
          <input id="events_filter" class="mr-1 leading-tight" type="checkbox" v-model="filters.events">
          <label for="events_filter" class="ml-2 text-grey-darker font-medium">
            <span class="text-sm uppercase">
              Events
            </span>
          </label>
          <input id="active_filters" class="mr-1 leading-tight" type="checkbox" v-model="filters.active">
          <label for="active_filters" class="ml-2 text-grey-darker font-medium">
            <span class="text-sm uppercase">
              Active
            </span>
          </label>
          <input id="inactive_filters" class="mr-1 leading-tight" type="checkbox" v-model="filters.inactive">
          <label for="inactive_filters" class="ml-2 text-grey-darker font-medium">
            <span class="text-sm uppercase">
              Inactive
            </span>
          </label>
          <button class="bg-tertiary text-white rounded-lg p-2 text-xs align-bottom" @click="resetFilter">
            <i class="fas fa-sync fa-xs"></i>
            Reset Filter
          </button>
        </div>
      </div>
    </div>

    <div class="mb-6 bg-white rounded-lg flex p-6 overflow-x-auto">
      <div class="w-full" v-if="loadingList">
        <loader class="text-center"/>
      </div>
      <div class="w-full" v-else>
        <table class="table-auto w-full">
          <thead class="border-b uppercase text-xs">
            <th class="pb-6 text-left pl-2 font-semibold">Type</th>
            <th class="pb-6 font-semibold text-left">Title</th>
            <th class="pb-6 font-semibold text-left">Menu</th>
            <th class="pb-6 font-semibold">Created</th>
            <th class="pb-6 font-semibold">Edit</th>
            <th class="pb-6 font-semibold">Active</th>
            <th class="pb-6 font-semibold">Delete</th>
          </thead>
          <tbody class="text-sm capitalize">
            <tr class="border-b" v-for="(item, index) in items" :key="index"
              :class="{ 'inactive': !item.active && canActivateItem(item) }">
              <td class="py-4 font-medium">
                <i class="w-4 text-base fa-fw mx-2" :class="item.icon" />
                {{ item.type.replace('-', ' ') }}
              </td>
              <td class="py-4 text-left font-medium">
                {{ item.title }}
              </td>
              <td class="py-4 text-left font-medium">
                {{ item.menu || '-' }}
              </td>
              <td class="py-4 text-center">
                <p>{{ item.created | date }}</p>
                <p>{{ item.created | time }}</p>
              </td>
              <td class="py-4 text-center">
                <router-link :to="`/admin/${item.type}/${itemId(item)}`" class="no-underline text-black">
                  <i class="text-base mr-1 far fa-edit fa-fw" />
                  Edit
                </router-link>
              </td>
              <td class="py-4 text-center">
                <div v-if="canActivateItem(item)">
                  <input :id="`active-${item.id}`" type="checkbox" :checked="item.active"
                    :disabled="!canActivateItem(item)" @click="switchActive(item)">
                  <label :for="`active-${item.id}`"></label>
                </div>
                <span v-else>-</span>
              </td>
              <td class="py-4 text-center">
                <button class="text-base" type="button" @click="deleteItem(item)">
                  <i v-if="item.isDeleting" class="fas fa-circle-notch fa-fw fa-spin" />
                  <i v-else class="far fa-trash-alt fa-fw" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import api from '@/http'
import admin from '@/mixins/Admin'

export default {
  mixins: [ admin ],
  created () {
    this.fetchAdmin(this.filters)
  },
  data () {
    let params = {
      search: '',
      menu: null,
      pages: true,
      news: true,
      alerts: true,
      events: true,
      active: true,
      inactive: true
    }
    const savedFilters = localStorage.getItem('admin.filters') ? JSON.parse(localStorage.getItem('admin.filters')) : {}
    Object.assign(params, savedFilters)
    return {
      filters: params,
      loadingList: false
    }
  },
  watch: {
    filters: {
      handler () {
        this.fetchAdminDelayed()
      },
      deep: true
    }
  },
  computed: {
    ...mapState([
      'profile', 'admin', 'menus'
    ]),
    items () {
      return this.admin.items
    }
  },
  methods: {
    ...mapActions([
      'fetchAdmin', 'deleteAdminItem', 'displayToastNotification'
    ]),
    async fetchAdminDelayed () {
      this.loadingList = true
      localStorage.setItem('admin.filters', JSON.stringify(this.filters))
      await this.fetchAdmin(this.filters)
      this.loadingList = false
    },
    canActivateItem (item) {
      return item.type !== 'event'
    },
    itemId (item) {
      return item.slug || item.id
    },
    switchActive (item) {
      item.active = !item.active

      api.patch(`/admin/toggle-active`, item)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteItem (item) {
      this.$set(item, 'isDeleting', true)
      this.deleteAdminItem(item)
        .then(response => {
          item.isDeleting = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Deleted',
            info: 'The item was deleted sucessfully.'
          })
        })
        .catch(error => {
          console.log(error)
          item.isDeleting = false
        })
    },
    resetFilter () {
      this.filters = {
        search: '',
        menu: null,
        pages: true,
        news: true,
        alerts: true,
        events: true,
        active: true,
        inactive: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
tr {
  td {
    &:first-child {
      @apply border-l-4 border-transparent;
    }
    &:last-child {
      @apply border-r-4 border-transparent;
    }
  }
}
.inactive {
  td {
    @apply bg-red-lightest;
    &:first-child {
      @apply border-l-4 border-red-lighter;
    }
    &:last-child {
      @apply border-r-4 border-red-lighter;
    }
  }
}
</style>
